import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  errorDialogOpen,
  errorDialogClose,
} from "../redux/dialogs/dialogActions";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
} from "@mui/material";
import { ErrorOutlined, CloseOutlined } from "@mui/icons-material";

const ErrorModal = () => {
  const dispatch = useDispatch();
  const errDialog = useSelector((state) => {
    return state.dialogReducer;
  });

  //   const logger = useSelector((state) => {
  //     return state.logger;
  //   });

  const handleToggle = () => {
    dispatch(errorDialogClose(""));
  };
  return (
    <>
      <Dialog
        open={errDialog.dialogErrorOpen}
        onClose={handleToggle}
        // sx={{
        //   "& .MuiDialog-container": {
        //     justifyContent: "center",
        //     alignItems: "flex-start",
        //   },
        // }}
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            borderBottom: "1px solid #ccc",
            padding: "3px",
          }}
        >
          <CloseOutlined style={{ cursor: "pointer" }} onClick={handleToggle} />
        </DialogTitle>
        <DialogContent>
          <div className="error-modal">
            <ErrorOutlined style={{ fontSize: 50 }} color="error" />
            <Typography variant="h5" style={{ textAlign: "center" }}>
              {errDialog.dialogErrorMessage !== "" ? (
                <span style={{ fontSize: 13 }}>
                  {errDialog.dialogErrorMessage}
                </span>
              ) : // <span>Please Login to Enrol</span>
              null}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" size="small" onClick={handleToggle}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ErrorModal;
